

import { createContext } from 'react'

const CostDivisionContext = createContext()

export default CostDivisionContext